export default class APIUtility {
    static WD_REQUEST_ID = "X-WD-REQUEST-ID";

    static makeGetRequest(url, requestKey, success, failure) {
        let headers = new Headers({'Content-Type': 'application/json'});
        APIUtility.makeRequest(url, 'GET', headers, requestKey, null, success, failure);
    }

    static makePostRequest(url, requestKey, body, success, failure) {
        let headers = new Headers({'Content-Type': 'application/json'});
        APIUtility.makeRequest(url, 'POST', headers, requestKey, body, success, failure);
    }

    static makePutRequest(url, requestKey, body, success, failure) {
        let headers = new Headers({'Content-Type': 'application/json'});
        APIUtility.makeRequest(url, 'PUT', headers, requestKey, body, success, failure);
    }

    static makeDeleteRequest(url, requestKey, body, success, failure) {
        let headers = new Headers({'Content-Type': 'application/json'});
        APIUtility.makeRequest(url, 'DELETE', headers, requestKey, body, success, failure);
    }

    static makeRequest(url, method, headers, requestKey, body, success, failure) {
        const commonId = document.getElementById(this.WD_REQUEST_ID).innerText;
        headers.append(this.WD_REQUEST_ID, commonId);
        fetch(BASE_PATH + url, {
            headers: headers,
            method: method,
            body: body,
            mode: 'cors',
            cache: 'default',
            credentials: 'include'
        }).then(response => {
          return response.json().then(responseBody => ({
                body: responseBody,
                status: response.status
              })
          )
        }).then(function (response) {
            // Deletes return an empty body on a status of 200
            if (response.status === 200) {
                if (method === 'DELETE') {
                    return {};
                }
                else {
                    return response.body;
                }
            }
            throw new RequestError('Response status other than 200: ' + response.status, response);

        }).then(function (data) {
            success(data);
        }).catch(function (error) {
            failure(error);
        });
    }
}

export const BASE_PATH = process.env.PUBLIC_URL;

export class RequestError extends Error {
    constructor(message, response) {
        super(message);
        this.status = response.status;
        this.body = response.body;
    }
}
